import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {ItemKey} from "../item/core/ItemKey";
import {Schema} from "@/common/Schema";


export class SearchConfig extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(SearchConfig, v) : SKIP;
            },
            (v) => {
                return deserialize(SearchConfig, v);
            }
        );
    }

    constructor() {
        super();
        this._minor = false;
        this._major = false
        this._skipLocked = false;
        this._sources = [];
    }

    get minor() {
        return this._minor;
    }

    set minor(value) {
        this._minor = value;
    }

    get major() {
        return this._major;
    }

    set major(value) {
        this._major = value;
    }

    get skipLocked() {
        return this._skipLocked;
    }

    set skipLocked(value) {
        this._skipLocked = value;
    }

    get sources() {
        return this._sources;
    }

    set sources(value) {
        this._sources = value;
    }

    valid() {

        if (this.sources && this.sources.some(v => !v || !v.valid() || v.any())) {
            return false;
        }

        return true;
    }

    empty() {
        return !(this.minor || this.major || this.sources.length > 0);
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SearchConfig());
        } else if (target instanceof SearchConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SearchConfig, {
    _minor: alias("minor", Schema.primitive()),
    _major: alias("major", Schema.primitive()),

    _skipLocked: alias("skip_locked", Schema.primitive()),

    _sources: alias("sources", list(ItemKey.schema()))
});